module.exports = __webpack_public_path__ + "static/media/hiring.93e23f00.svg";